import { ReactComponent as AreaChartIcon } from '../../assets/icons/chart/chart-icon-area.svg';
import { ReactComponent as AreaChartColoredIcon } from '../../assets/icons/chart/chart-icon-area-colored.svg';
import { ReactComponent as BarChartIcon } from '../../assets/icons/chart/chart-icon-vertical-bar.svg';
import { ReactComponent as BarChartColoredIcon } from '../../assets/icons/chart/chart-icon-vertical-bar-colored.svg';
import { ReactComponent as HorizontalBarChartIcon } from '../../assets/icons/chart/chart-icon-horizontal-bar.svg';
import { ReactComponent as HorizontalBarChartColoredIcon } from '../../assets/icons/chart/chart-icon-horizontal-bar-colored.svg';
import { ReactComponent as TableChartIcon } from '../../assets/icons/chart/chart-icon-table.svg';
import { ReactComponent as TableChartColoredIcon } from '../../assets/icons/chart/chart-icon-table-colored.svg';
import { ReactComponent as LineChartIcon } from '../../assets/icons/chart/chart-icon-line.svg';
import { ReactComponent as LineChartColoredIcon } from '../../assets/icons/chart/chart-icon-line-colored.svg';
import { ReactComponent as PieChartIcon } from '../../assets/icons/chart/chart-icon-pie.svg';
import { ReactComponent as PieChartColoredIcon } from '../../assets/icons/chart/chart-icon-pie-colored.svg';
import { ReactComponent as DonutChartIcon } from '../../assets/icons/chart/chart-icon-donut.svg';
import { ReactComponent as DonutChartColoredIcon } from '../../assets/icons/chart/chart-icon-donut-colored.svg';
import { ReactComponent as NumberChartIcon } from '../../assets/icons/chart/chart-icon-number.svg';
import { ReactComponent as NumberChartColoredIcon } from '../../assets/icons/chart/chart-icon-number-colored.svg';
import { ReactComponent as PivotTableChartIcon } from '../../assets/icons/chart/chart-icon-pivot-table.svg';
import { ReactComponent as PivotTableChartColoredIcon } from '../../assets/icons/chart/chart-icon-pivot-table-colored.svg';
import { ReactComponent as ScatterChartIcon } from '../../assets/icons/chart/chart-icon-scatter.svg';
import { ReactComponent as ScatterChartColoredIcon } from '../../assets/icons/chart/chart-icon-scatter-colored.svg';
import { ReactComponent as HistogramChartIcon } from '../../assets/icons/chart/chart-icon-histogram.svg';
import { ReactComponent as HistogramChartColoredIcon } from '../../assets/icons/chart/chart-icon-histogram-colored.svg';
import { ReactComponent as TreemapChartIcon } from '../../assets/icons/chart/chart-icon-treemap.svg';
import { ReactComponent as TreemapChartColoredIcon } from '../../assets/icons/chart/chart-icon-treemap-colored.svg';
import { ReactComponent as HeatmapChartIcon } from '../../assets/icons/chart/chart-icon-heatmap.svg';
import { ReactComponent as HeatmapChartColoredIcon } from '../../assets/icons/chart/chart-icon-heatmap-colored.svg';
import { ReactComponent as VerticalStackedBarChartIcon } from '../../assets/icons/chart/chart-icon-vertical-stacked-bar.svg';
import { ReactComponent as VerticalStackedBarChartColoredIcon } from '../../assets/icons/chart/chart-icon-vertical-stacked-bar-colored.svg';
import { ReactComponent as HorizontalStackedBarChartIcon } from '../../assets/icons/chart/chart-icon-horizontal-stacked-bar.svg';
import { ReactComponent as HorizontalStackedBarChartColoredIcon } from '../../assets/icons/chart/chart-icon-horizontal-stacked-bar-colored.svg';
import { ReactComponent as ClusteredBarComboChartIcon } from '../../assets/icons/chart/chart-icon-clustered-bar-combo.svg';
import { ReactComponent as ClusteredBarComboChartColoredIcon } from '../../assets/icons/chart/chart-icon-clustered-bar-combo-colored.svg';
import { ReactComponent as StackedBarComboChartIcon } from '../../assets/icons/chart/chart-icon-stacked-bar-combo-chart.svg';
import { ReactComponent as StackedBarComboChartColoredIcon } from '../../assets/icons/chart/chart-icon-stacked-bar-combo-chart-colored.svg';
import { ReactComponent as FunnelChartIcon } from '../../assets/icons/chart/chart-icon-funnel.svg';
import { ReactComponent as FunnelChartColoredIcon } from '../../assets/icons/chart/chart-icon-funnel-colored.svg';

// ----------------------------------------------------------------------
//const getIcon = (name, selected) => <Icon className={`blk_icon ${selected ? "cm_select_graph" : ""}`} icon={name} width={35} height={35} />;
//const getCustomIcon = (name, selected) => <span className={`blk_icon ${selected ? "cm_select_graph" : ""}`}>{name}</span>;
const getChartIcon = (icon, iconSelected, selected) => {
    return <span className={`blk_icon`}>{selected ? iconSelected : icon}</span>
};

//#region operator
// minOr : minDimension OR minMeasure
// minAnd_maxAnd : minDimension AND minMeasure    AND   maxDimension AND maxMeasure
//#endregion

const StaticGraphTypesConfig = [
    {
        label: 'TimeView',
        value: 'timeView',
        icon: ({ selected }) => getChartIcon(<TableChartIcon />, <TableChartColoredIcon />, selected),
        requireField: {
            label: "1 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 1,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'ListView',
        value: 'listView',
        icon: ({ selected }) => getChartIcon(<TableChartIcon />, <TableChartColoredIcon />, selected),
        requireField: {
            label: "Measures or Dimensions",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 1,
            maxMeasure: 1,
            operator: "any"
        }
    },
    {
        label: 'ProgressView',
        value: 'progressView',
        icon: ({ selected }) => getChartIcon(<TableChartIcon />, <TableChartColoredIcon />, selected),
        requireField: {
            label: "1 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 1,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    
];

export default StaticGraphTypesConfig;
